export const LOGOS_BUCKET = 'logos'

export const FILE_UPLOAD_HELP_URL =
  'https://help.govwell.com/en/articles/15070923-i-m-trying-to-upload-a-pdf-file-but-the-website-is-returning-an-error'

export enum PathPrefixes {
  CodeBookImports = 'code-book-imports',
  CorrectionsReports = 'corrections-reports',
  DocumentTemplates = 'document-templates',
  GLNumberReports = 'gl-number-reports',
  Logos = 'logos',
  MeetingSchedules = 'meeting-schedules',
  Invoices = 'invoices',
  NewPermitTypeForm = 'new-permit-type-form',
  PaymentTransferCsvs = 'payment-transfer-csvs',
  Receipts = 'receipts',
  RecordsCsvs = 'records-csvs',
  RecordsReports = 'records-reports',
  RecordTaskFeesCsv = 'record-task-fees-csvs',
  RecordTaskInspectionAttemptsCsvs = 'record-task-inspection-attempts-csvs',
  RecordTaskInspectionAttemptsReports = 'record-task-inspection-attempts-reports',
  Signatures = 'signatures',
  StampTemplates = 'stamp-templates',
  SupportForm = 'support-form',
  ViolationCases = 'violation-cases',
  ViolationFiles = 'violation-files',
  ViolationInspectionPhotos = 'violation-inspection-photos',
  ViolationMailers = 'violation-mailers',
}
